let meetingLinkRoutes = [
    {
		path: '/meetings-link',
		name: 'MeetingsLink',
        meta: {
            requiresAuth: true,
            allowAuthenticated: true,
            title: 'Meetings Link | Appointment Portal RDCD',
            displayTitle: 'page-titles.meetings-link',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
            
        },
        layout: "dashboard",
		component: () => import(/* webpackChunkName: 'communications' */ '../views/meetings-link/MeetingsLink.vue'),
	},
    {
		path: '/meetings-link/create',
		name: 'CreateMeetingLink',
        layout: "dashboard",
		component: () => import('../views/meetings-link/CreateMeetingLink.vue'),
		meta: {
            requiresAuth: true,
            title: 'Create Meeting Link | Appointment Portal RDCD',
            displayTitle: 'meeting-link-create-page.title',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
    {
		path: '/meetings-link/edit',
		name: 'EditMeetingLink',
        layout: "dashboard",
		component: () => import('../views/meetings-link/EditMeetingLink.vue'),
		meta: {
            requiresAuth: true,
            title: 'Edit Meeting Link | Appointment Portal RDCD',
            displayTitle: 'meeting-link-update-page.title',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
];
export { meetingLinkRoutes };